var bighouse = bighouse || {};

bighouse.sagepay = (function () {
    const form = document.getElementById('bookingPaymentForm');
    const formSubmit = form != null ? form.querySelector('input[type="submit"]') : null;
    
    function init() {
        bindEvents();
    }

    function bindEvents() {
        if(formSubmit != null) {
            formSubmit.addEventListener("click", processTransaction, false);
        }
    }

    function processTransaction() {
        sagepayOwnForm({ merchantSessionKey: "@Model.MerchantSessionModel.MerchantSessionKey" })
            .tokeniseCardDetails({
                cardDetails: {
                    cardholderName: document.querySelector('[data-card-details="cardholder-name"]').value,
                    cardNumber: document.querySelector('[data-card-details="card-number"]').value,
                    expiryDate: document.querySelector('[data-card-details="expiry-date"]').value,
                    securityCode: document.querySelector('[data-card-details="security-code"]').value
                },
                    onTokenised : function(result) {
                        if (result.success) {
                            document.getElementById("cardIdentifier").value = result.cardIdentifier;
                        document.querySelector('form').submit();
                    } else {
                        alert(JSON.stringify(result));
                    }
                }
            });
    }

    return {
        init: init
    };
})();